import { Amplify } from 'aws-amplify';
import { SETTINGS } from './settings';
//https://docs.amplify.aws/lib/restapi/getting-started/q/platform/js#manual-setup-import-existing-rest-api

Amplify.configure(SETTINGS.aws.AwsConfig);
